import React, { FC } from "react";
import { isMobile } from "react-device-detect";


const Footer:FC = () => {
    const year = new Date().getFullYear();

    return <div style={{maxHeight:'20px',width:'100%', 'margin':'2rem 0rem 1rem 0rem'}}>
        <hr style={{backgroundColor:'#F1F3F6', height:'2pt'}} />
        <div className='ion-display-flex ion-justify-content-between' style={isMobile ?{margin:'0px 2rem',flexDirection:'column', textAlign:'center'}: {margin:'0px 2rem'}}>
            <div className="font-helvetica font-med font-13pt text-footer-blue"> © 2019 - {year} Alpha Controls & Services, LLC All Rights Reserved. </div>
            <div className="font-helvetica font-med font-13pt"> 
                <a className="text-footer-blue" href="/privacy" target="_blank" style={{marginRight:'1rem', textDecoration:'none'}}> Privacy Policy </a>
                <a className="text-footer-blue" href="/terms_and_conditions" target="_blank" style={{textDecoration:'none'}}> Terms of Use</a>
                </div>
        </div>
    </div>
};

export default Footer;